var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardVidaAgro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 67",
    style: {
      enableBackground: "new 0 0 64 67"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#95D4E9;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DASHBOARD_VIDA_Y_AGRO",
    transform: "translate(-1490.133 -287.133)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4546",
    className: "st0",
    d: "M1493.1,288.1h58c1.1,0,2,0.9,2,2v61c0,1.1-0.9,2-2,2h-58c-1.1,0-2-0.9-2-2v-61 C1491.1,289,1492,288.1,1493.1,288.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19056",
    className: "st1",
    d: "M1502.7,333.5L1502.7,333.5c-3.1,0-5.6-2.5-5.6-5.6c0,0,0,0,0,0V325c0-3.1,2.5-5.6,5.6-5.6 c0,0,0,0,0,0l0,0c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0,0,0v2.8C1508.3,330.9,1505.8,333.5,1502.7,333.5 C1502.7,333.5,1502.7,333.5,1502.7,333.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19057",
    className: "st1",
    d: "M1522.5,319.4L1522.5,319.4c-3.1,0-5.6-2.5-5.6-5.6c0,0,0,0,0,0V311c0-3.1,2.5-5.6,5.6-5.6 c0,0,0,0,0,0l0,0c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0,0,0v2.8C1528.1,316.9,1525.6,319.4,1522.5,319.4 C1522.5,319.4,1522.5,319.4,1522.5,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19058",
    className: "st1",
    d: "M1542.1,327.8L1542.1,327.8c-3.1,0-5.6-2.5-5.6-5.6c0,0,0,0,0,0v-2.8 c0-3.1,2.5-5.6,5.6-5.6c0,0,0,0,0,0l0,0c3.1,0,5.6,2.5,5.6,5.6c0,0,0,0,0,0v2.8C1547.8,325.3,1545.2,327.8,1542.1,327.8 C1542.1,327.8,1542.1,327.8,1542.1,327.8z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_34",
    className: "st0",
    x1: 1503.1,
    y1: 300.1,
    x2: 1503.1,
    y2: 319.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_35",
    className: "st0",
    x1: 1503.1,
    y1: 334.1,
    x2: 1503.1,
    y2: 339.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_36",
    className: "st0",
    x1: 1522.1,
    y1: 300.1,
    x2: 1522.1,
    y2: 305.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_37",
    className: "st0",
    x1: 1522.1,
    y1: 319.1,
    x2: 1522.1,
    y2: 339.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_38",
    className: "st0",
    x1: 1542.1,
    y1: 300.1,
    x2: 1542.1,
    y2: 314.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_39",
    className: "st0",
    x1: 1542.1,
    y1: 327.1,
    x2: 1542.1,
    y2: 339.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardVidaAgro);
export default __webpack_public_path__ + "static/media/Dashboard-Vida-Agro.b56b28d8d33ba47ad77cc8a1fe8a9e31.svg";
export { ForwardRef as ReactComponent };